<div class="container">
  <div class="contenedor-datos-basicos">
    <p class="title-approbe">
      Completa tus datos para obtener tu cupo con Approbe
    </p>

    <form [formGroup]="formDates">

      <section class="container-personal-information">

        <mat-form-field class="styled-field" appearance="outline">
          <mat-label>Primer nombre</mat-label>
          <input matInput type="text" formControlName="primerNombre"  (keydown)="preventSpace($event)" />

          <mat-error *ngIf="formDates.get('primerNombre')?.hasError('required')">
            El primer nombre es obligatorio.
          </mat-error>

          <mat-error *ngIf="formDates.get('primerNombre')?.hasError('pattern')">
            Nombre no puede contener numeros
          </mat-error>

          <mat-error *ngIf="formDates.get('primerNombre')?.hasError('isSpecialCharacters')">
            El campo no puede estar vacio o el nombre es incorrecto
          </mat-error>

        </mat-form-field>

        <mat-form-field class="styled-field" appearance="outline">
          <mat-label>Primer apellido</mat-label>
          <input matInput type="text" formControlName="primerApellido"  (keydown)="preventSpace($event)" />

          <mat-error *ngIf="formDates.get('primerApellido')?.hasError('required')">
            El primer apellido es obligatorio.
          </mat-error>

          <mat-error *ngIf="formDates.get('primerApellido')?.hasError('pattern')">
            Apellido no puede contener numeros
          </mat-error>

          <mat-error *ngIf="formDates.get('primerApellido')?.hasError('isSpecialCharacters')">
            El campo no puede estar vacio o el apellido es incorrecto
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput type="text" formControlName="email"  (keydown)="preventSpace($event)" />

          <mat-error *ngIf="formDates.get('email')?.hasError('required')">
            El email es obligatorio.
          </mat-error>

          <mat-error *ngIf="formDates.get('email')?.hasError('email')">
            El valor ingresado no es un email válido.
          </mat-error>
          <mat-error *ngIf="formDates.get('email')?.hasError('isSpecialCharacters')">
            El campo no puede estar vacio o el email es incorrecto
          </mat-error>
        </mat-form-field>

      </section>

      <!-- INCIIO COMPONENTE DE FECHA DE NACIMIENTO -->

      <p class="title-forms">Fecha de <b>Nacimiento</b></p>

      <section class="container--dates">

        <mat-form-field appearance="outline">
          <mat-label>Día</mat-label>
          <mat-select formControlName="diaNacimiento">
            <mat-option *ngFor="let day of days" [value]="day">{{ day }}</mat-option>
          </mat-select>
          <mat-error *ngIf="formDates.get('diaNacimiento')?.hasError('required')">
            Campo obligatorio
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Mes</mat-label>
          <mat-select formControlName="mesNacimiento">
            <mat-option *ngFor="let month of months" [value]="month.value">{{ month.name }}</mat-option>
          </mat-select>
          <mat-error *ngIf="formDates.get('mesNacimiento')?.hasError('required')">Campo obligatorio</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Año</mat-label>
          <mat-select formControlName="anioNacimiento">
            <mat-option *ngFor="let year of bornYears" [value]="year">{{ year }}</mat-option>
          </mat-select>
          <mat-error *ngIf="formDates.get('anioNacimiento')?.hasError('required')">Campo obligatorio</mat-error>
        </mat-form-field>

      </section>

      <!-- COMPONENTE DE FECHA EXPEDICIÓN -->

      <p class="title-forms">Fecha de <b>expedición</b> de tu <b>cédula</b></p>

      <section class="container--dates">

        <mat-form-field appearance="outline">
          <mat-label>Día</mat-label>
          <mat-select formControlName="dia">
            <mat-option *ngFor="let day of days" [value]="day">{{ day }}</mat-option>
          </mat-select>
          <mat-error *ngIf="formDates.get('dia')?.hasError('required')">Campo obligatorio</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Mes</mat-label>
          <mat-select formControlName="mes">
            <mat-option *ngFor="let month of months" [value]="month.value">{{ month.name }}</mat-option>
          </mat-select>
          <mat-error *ngIf="formDates.get('mes')?.hasError('required')">Campo obligatorio</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Año</mat-label>
          <mat-select formControlName="anio">
            <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
          </mat-select>
          <mat-error *ngIf="formDates.get('anio')?.hasError('required')">Campo obligatorio</mat-error>
        </mat-form-field>

      </section>

      <!-- FIN DE COMPONENTE DE FECHA EXPEDICIÓN -->

      <mat-form-field appearance="outline">
        <mat-label>Dirección</mat-label>
        <input matInput type="text" formControlName="direccion" type="text"
          placeholder="Ingresa tu dirección" (focus)="showSuggestions = addressSuggestions.length > 0">

        <mat-error *ngIf="formDates.get('direccion')?.hasError('required')">
          La dirección es un campo requerido.
        </mat-error>

        <mat-error *ngIf="formDates.get('direccion')?.hasError('notSelected')">
          Debes seleccionar una dirección de la lista.
        </mat-error>
      </mat-form-field>

      <div class="suggestions" *ngIf="showSuggestions">
        <div class="suggestion-item" *ngFor="let suggestion of addressSuggestions"
          (click)="selectAddress(suggestion)">
          {{ suggestion.description || suggestion.formatted_address }}
        </div>
      </div>


      <button [disabled]="!formDates.valid" id="gtmBnplValidarIdentidad" class="btn btn-azul btn-redondo"
        (click)="sendPersonalInformation()">
        Continuar
      </button>

    </form>
  </div>
</div>